import { MdbStickyDirective } from './sticky-content.directive';
import { MdbStickyModule } from './sticky-content.module';
export { MdbStickyDirective, MdbStickyModule };



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/sticky-content/index.ts